function carousel(){
    const container = window.document.querySelector('.js_custom-carousel-container');

    if (!container) return;

    const {Flickity} = themeVendor;

    const speed = container?.getAttribute('data-speed'); 
    
    let tickerSpeed = speed / 10;
    let slider = null;
    let isPaused = false;
    
    const update = () => {
      if (isPaused) return;
      if (slider.slides) {
        slider.x = (slider.x - tickerSpeed) - slider.slideableWidth;
        slider.selectedIndex = slider.dragEndRestingSelect();
        slider.updateSelectedSlide();
        slider.settle(slider.x);
      }
      window.requestAnimationFrame(update);
    };

    const pause = () => {
      isPaused = true;
    };

    const play = () => {
      if (isPaused) {
        isPaused = false;
        window.requestAnimationFrame(update);
      }
    };

    slider = new Flickity(container, {
      autoPlay: false,
      prevNextButtons: false,
      pageDots: false,
      draggable: false,
      wrapAround: true,
      selectedAttraction: 0.015,
      friction: 0.25,
      watchCSS: true
    });

    slider.x = 0;    
    
    container.addEventListener('mouseenter', pause, false);
    container.addEventListener('focusin', pause, false);
    container.addEventListener('mouseleave', play, false);
    container.addEventListener('focusout', play, false);

    // slider.on('dragStart', () => {
    //   isPaused = true;
    // });

    update();
}

window.addEventListener('load',carousel);
